import { Box, Grid } from "@mui/material";
import Thumbnail from "Components/Thumbnail";
import Tile from "Components/Tiles/Tile";
import { CollectionSession, SessionDocumentType } from "system/Domain";
import SalesDocumentTitle from "../Shipping/SalesDocumentTitle";

interface Props {
	session: CollectionSession
	canEdit: boolean
	onDelete: (hash: string) => Promise<void>
}

export const sessionDocumentTypes: { [key in SessionDocumentType]: string } = {
	BillOfLading: "Frachtpapiere",
	Other: "Andere"
};

const CollectionSessionDocuments = ({ session, canEdit, onDelete }: Props) => {
	const documents = (session.documents ?? []).filter(d => d.isCurrent);

	if (documents.length === 0) return null;

	return (
		<Box mt={2}>
			<Tile title="Dokumente (für alle Fahrzeuge der Sitzung)">
				<Grid container spacing={2}>
					{documents.map(d => (
						<Grid key={d.file.hash} item>
							<SalesDocumentTitle
								title={sessionDocumentTypes[d.documentType] ?? d.documentType}
								onClose={canEdit ? () => onDelete(d.file.hash) : undefined}
							/>
							<Thumbnail
								width={300}
								height={400}
								asyncUrl={`/api/storage/${d.file.hash}/thumbnail`}
								downloadUrl={`/api/storage/${d.file.hash}`}
								standalone
							/>
						</Grid>
					))}
				</Grid>
			</Tile>
		</Box>
	);
};

export default CollectionSessionDocuments;
